"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.redeemBirthdayGift = exports.fetchBirthdayGift = void 0;
var unfetch_1 = __importDefault(require("unfetch"));
var subscriptions_api_1 = require("../../misc/subscriptions-api");
var index_1 = require("./index");
var fetchBirthdayGift = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var clientArgs, res, birthdayPromo, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!id) {
                    return [2 /*return*/];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                clientArgs = (0, subscriptions_api_1.getClientArgs)({ customerHash: (0, index_1.getCustomerHash)(), path: "/birthday-gifts" });
                return [4 /*yield*/, (0, unfetch_1.default)("".concat(clientArgs.uri, "?") +
                        new URLSearchParams({
                            birthdayGiftId: id,
                        }), {
                        headers: __assign(__assign({}, clientArgs.headers), { 'Content-Type': 'application/json' }),
                    })];
            case 2:
                res = _a.sent();
                return [4 /*yield*/, res.json()];
            case 3:
                birthdayPromo = _a.sent();
                return [2 /*return*/, birthdayPromo];
            case 4:
                e_1 = _a.sent();
                console.error('Error: ', e_1);
                return [2 /*return*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.fetchBirthdayGift = fetchBirthdayGift;
var redeemBirthdayGift = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var birthdayGiftId, variantId, clientArgs, response, redemptionResponse, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                birthdayGiftId = params.birthdayGiftId, variantId = params.variantId;
                clientArgs = (0, subscriptions_api_1.getClientArgs)({ customerHash: (0, index_1.getCustomerHash)(), path: "/birthday-gifts/redeem" });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, (0, unfetch_1.default)(clientArgs.uri, {
                        method: 'POST',
                        body: JSON.stringify({
                            birthdayGiftId: birthdayGiftId,
                            variantId: variantId,
                        }),
                        headers: __assign(__assign({}, clientArgs.headers), { 'Content-Type': 'application/json' }),
                    })];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 3:
                redemptionResponse = _a.sent();
                return [2 /*return*/, redemptionResponse];
            case 4:
                e_2 = _a.sent();
                console.error('Error: ', e_2);
                return [2 /*return*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.redeemBirthdayGift = redeemBirthdayGift;
